import script from "./CustomIconButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomIconButton.vue?vue&type=script&lang=ts&setup=true"

import "./CustomIconButton.vue?vue&type=style&index=0&id=d18a5cbe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d18a5cbe"]])

export default __exports__